import { render, staticRenderFns } from "./icon-printer.vue?vue&type=template&id=5f257889"
import script from "./icon-printer.vue?vue&type=script&lang=ts"
export * from "./icon-printer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports